// Logout Page
import Logout from "pages/Authentication/Logout"
// Dashboard Page
import Dashboard from "pages/Dashboard"
// Un Authorize page
import UnAuthorized from "pages/errors/UnAuthorized"
import React from "react"

// Warehouse lis page for admin
import WarehouseList from "pages/Admin/Warehouse"

// Warehouse add page for admin
import AddWarehouse from "pages/Admin/Warehouse/add"

// Provider list page for admin
import ProviderList from "pages/Admin/Providers"

// Provider add page for admin
import AddProvider from "pages/Admin/Providers/add"

// Warehouse update page for admin
import EditWarehouse from "pages/Admin/Warehouse/update"

// Provider update page for admin
import EditProvider from "pages/Admin/Providers/update"

// Province list page for admin
import ProvinceList from "pages/Admin/Province"

// Province update page for admin
import EditProvince from "pages/Admin/Province/update"

// Facility list page for admin
import FacilityList from "pages/Admin/Facility"

// Facility add page for admin
import AddFacility from "pages/Admin/Facility/add"

// Facility update page for admin
import EditFacility from "pages/Admin/Facility/update"

// Ip list page for admin
import IPList from "pages/Admin/IP"

// Ip add page for admin
import AddIP from "pages/Admin/IP/add"

// Ip update page for admin
import EditIP from "pages/Admin/IP/update"

// Item category list page for admin
import ItemCategoryList from "pages/Admin/ItemCategory"

// Item category add page for admin
import AddItemCategory from "pages/Admin/ItemCategory/add"

// Item category update page for admin
import EditItemCategory from "pages/Admin/ItemCategory/update"

// Item list page for admin
import ItemList from "pages/Admin/Item"

// Item add page for admin
import AddItem from "pages/Admin/Item/add"

// Item update page for admin
import EditItem from "pages/Admin/Item/update"

// User list page for admin
import UserList from "pages/Admin/User"

// User add page for admin
import AddUser from "pages/Admin/User/add"

// User update page for admin
import EditUser from "pages/Admin/User/update"

// Role list page for admin
import RoleList from "pages/Admin/Role"

// Role update page for admin
import EditRole from "pages/Admin/Role/update"

// Project list page for admin
import ProjectList from "pages/Admin/Project"

// Project add page for admin
import AddProject from "pages/Admin/Project/add"

// Project update page for admin
import EditProject from "pages/Admin/Project/update"

// Profile page
import Profile from "pages/Profile"

// Provider chart items in dashboard page
import ProviderChartInItems from "pages/Provider/Dashboard/ProviderChartInItems"

// Provider chart other source items dashboard page
import ProviderOtherSourceItems from "pages/Provider/Dashboard/ProviderOtherSourceItems"

// Provider chart exchange items dashboard page
import ProviderExchangeItems from "pages/Provider/Dashboard/ProviderExchangeItems"

// Provider adjustment increase items dashboard page
import ProviderAdjustmentIncrease from "pages/Provider/Dashboard/ProviderAdjustmentIncrease"

// Provider adjustment decrease items dashboard page
import ProviderAdjustmentDecrease from "pages/Provider/Dashboard/ProviderAdjustmentDecrease"

// Provider chart  items out dashboard page
import ProviderChartOutItems from "pages/Provider/Dashboard/ProviderChartOutItems"

// Provider province detail page
import ProviderProvinceDetail from "pages/Provider/Dashboard/ProviderProvinceDetail"

// Provider ip chart in items dashboard page
import ProviderIPsChartInItems from "pages/Provider/Dashboard/ProviderIPsChartInItems"

// Provider ip chart out items dashboard page
import ProviderIPsChartOutItems from "pages/Provider/Dashboard/ProviderIPsChartOutItems"

// Provider in list page for provider
import ProviderInList from "pages/Provider/ProviderIn"

// Provider in add page for provider
import AddProviderIn from "pages/Provider/ProviderIn/add"

// Provider in update page for provider
import EditProviderIn from "pages/Provider/ProviderIn/update"
import EditProviderInDraft from "pages/Provider/ProviderIn/updateDraft"

// Provider out list page for provider
import ProviderOutList from "pages/Provider/ProviderOut"

// Provider out add page for provider
import AddProviderOut from "pages/Provider/ProviderOut/add"

// Provider out update page for provider
import EditProviderOut from "pages/Provider/ProviderOut/update"

// Provider out draft update page for provider
import EditProviderOutDraft from "pages/Provider/ProviderOut/updateDraft"

// Provider out update page for provider
import ProviderExpireReceiptList from "pages/Provider/ExpireReceipts"

// Transfer to Facility page for provider
import TransferToFacilityList from "pages/Provider/TransferToFacility"

//Re-allocation Items page for provider
import ReturnedItemsList from "pages/Provider/ReturnedItems"

//Re-allocation Management page for admin
import ReturnRequestsList from "pages/Admin/ReturnRequests"

// Provider Transfer Requests page for admin
import AdminProviderTransfers from "pages/Admin/ProviderTransfers"

// Provider Transfer History page for provider
import ProviderTransferList from "pages/Provider/ProviderTransfers"

// Consumption list for provider
import ProviderConsumptionList from "pages/Provider/Consumptions"

// Transaction list for provider
import ProviderTransactionList from "pages/Provider/Reports/transaction"

// Receipt report page for  provider
import ProviderReceiptReportList from "pages/Provider/Reports/ReceiptReport"

// Distribution report page for  provider
import ProviderDistributionReportList from "pages/Provider/Reports/DistributionReport"

// Ip distribution report page for  provider
import ProviderProvinceDistributionReportList from "pages/Provider/Reports/IPDistributionReport"

// Inventory report page for  provider
import ProviderInventoryList from "pages/Provider/Reports/Inventory"

// Province Chart  items in dashboard page
import ProvinceChartInItems from "pages/Province/Dashboard/ProvinceChartInItems"

// Province Chart  items out dashboard page
import ProvinceChartOutItems from "pages/Province/Dashboard/ProvinceChartOutItems"

// Province map drill-down detail page
import ProvinceProvinceDetail from "pages/Province/Dashboard/ProvinceProvinceDetail"

// Province province in page
import ProvinceInList from "pages/Province/ProvinceIn"

// Province province out page
import ProvinceOutList from "pages/Province/ProvinceOut"

// Province province out add  page
import AddProvinceOut from "pages/Province/ProvinceOut/add"

// Province province out update  page
import EditProvinceOut from "pages/Province/ProvinceOut/update"

// Province expire receipts page
import ProvinceExpireReceiptList from "pages/Province/ExpireReceipts"

// Consumtion list page for province
import ProvinceConsumptionList from "pages/Province/Consumptions"

// Transaction report page for province
import ProvinceTransactionList from "pages/Province/Reports/transaction"

// Chart item in page for monitor
import MonitorChartInItems from "pages/Monitor/Dashboard/MonitorChartInItems"

// Chart item out page for monitor
import MonitorChartOutItems from "pages/Monitor/Dashboard/MonitorChartOutItems"

// Monitor province map drill-down detail page
import MonitorProvinceDetail from "pages/Monitor/Dashboard/MonitorProvinceDetail"

// Ip chart item in page for monitor
import MonitorIPsChartInItems from "pages/Monitor/Dashboard/MonitorIPsChartInItems"

// Ip chart items out page for monitor
import MonitorIPsChartOutItems from "pages/Monitor/Dashboard/MonitorIPsChartOutItems"

// Receipts list page for monitor
import MonitorReceipts from "pages/Monitor/Receipts"

// Distributions page for monitor
import MonitorDistributions from "pages/Monitor/Distributions"

// Expire receipts page for monitor
import MonitorExpireReceiptList from "pages/Monitor/ExpireReceipts"

// Transaction page for monitor
import MonitorTransactionList from "pages/Monitor/Reports/transaction"

// receipt report page for monitor
import MonitorReceiptReportList from "pages/Monitor/Reports/ReceiptReport"

// Distribution report page for monitor
import MonitorDistributionReportList from "pages/Monitor/Reports/DistributionReport"

// Ip distribution report page for monitor
import MonitorProvinceDistributionReportList from "pages/Monitor/Reports/IPDistributionReport"

// Inventory report page for monitor
import MonitorInventoryList from "pages/Monitor/Reports/Inventory"

// Activity logs page for admin
import ActivityLogsList from "pages/Admin/ActivityLogs"

// Provider action receipts requests page for admin
import ProviderReceiptActionRequestList from "pages/Admin/ProviderActionRequests/receipts"

// Provider action distributions  requests page for admin
import ProviderDistributionActionRequestList from "pages/Admin/ProviderActionRequests/distributions"

// Adjustment action requests page for admin
import AdjustmentActionRequestList from "pages/Admin/ProviderActionRequests/adjustments"

// Consumption report page for provider
import ProviderConsumptionReportList from "pages/Provider/Reports/ConsumptionReport"

// transaction by project report page for provider
import ProviderTransactionByProjectList from "pages/Provider/Reports/transactionByProject"

// Consumption report page for monitor
import MonitorConsumptionReportList from "pages/Monitor/Reports/ConsumptionReport"

// receipt health report page for provider
import ProviderReceiptHealthReportList from "pages/Provider/Reports/receiptHealthReport"

// Expire list based12 month page for provider
import ProviderExpireReceiptListBased12Month from "pages/Provider/ExpireReceipts/ExpireListBased12Month"

// Stock out page for provider
import ProviderStockOut from "pages/Provider/StockOut"

// Quantification report page for provider
import ProviderQuantificationReport from "pages/Provider/Reports/QuantificationReport"

// Quantification Organization report page for provider
import ProviderQuantificationOrganizationReport from "pages/Provider/Reports/QuantificationOrganization"

// Consumption Organization report2 page for provider
import ProviderConsumptionReportList2 from "pages/Provider/Reports/ConsumptionReport2"

// Consumption Organization report page for province
import ProvinceConsumptionReportList from "pages/Province/Reports/ConsumptionReport"

// Distributions province action request page for provider
import ProvinceDistributionActionRequestList from "pages/Provider/ProvinceActionRequest/distributions"

// Expire list based12 month page for monitor
import MonitorExpireReceiptListBased12Month from "pages/Monitor/ExpireReceipts/ExpireListBased12Month"

// Stock out page for monitor
import MonitorStockOut from "pages/Monitor/StockOut"

// Consumption report2 page for monitor
import MonitorConsumptionReportList2 from "pages/Monitor/Reports/ConsumptionReport2"

// receipt health report page for monitor
import MonitorReceiptHealthReportList from "pages/Monitor/Reports/receiptHealthReport"

// Quantification report page for monitor
import MonitorQuantificationReport from "pages/Monitor/Reports/QuantificationReport"

// Quantification organization report page for monitor
import MonitorQuantificationOrganizationReport from "pages/Monitor/Reports/QuantificationOrganization"
// M&E Report page for provider
import ProviderMEReport from "pages/Provider/Reports/MEReport"
// Adjustment pages
import AdjustmentList from "pages/Provider/Adjustment"
import AddAdjustment from "pages/Provider/Adjustment/add"
import EditAdjustment from "pages/Provider/Adjustment/update"

// Unit Classification pages for admin
import CommodityClassificationList from "pages/Admin/CommodityClassification"
import AddCommodityClassification from "pages/Admin/CommodityClassification/add"
import EditCommodityClassification from "pages/Admin/CommodityClassification/update"
import FundCodeList from "pages/Admin/FundCode"
import AddFundCode from "pages/Admin/FundCode/add"
import EditFundCode from "pages/Admin/FundCode/update"
import ShipmentList from "pages/Admin/Shipment"
import AddShipment from "pages/Admin/Shipment/add"
import EditShipment from "pages/Admin/Shipment/update"

// Currency list page for admin
import CurrencyList from "pages/Admin/Currency"

// Currency add page for admin
import AddCurrency from "pages/Admin/Currency/add"

// Currency update page for admin
import EditCurrency from "pages/Admin/Currency/update"

// Role add page for admin
import AddRole from "pages/Admin/Role/add"

export const childrenRoutes = [
  // Dashboard Route
  {
    path: "dashboard",
    element: <Dashboard />,
    allowRoles: [],
  },
  // Warehouse Route
  {
    path: "warehouse",
    element: <WarehouseList />,
    allowPermission: "show-warehouse",
    allowRoles: ["Admin", "Provider", "Province"],
  },
  // Add new Warehouse Route
  {
    path: "add-warehouse",
    element: <AddWarehouse />,
    allowPermission: "create-warehouse",
    allowRoles: ["Admin", "Provider", "Province"],
  },
  // Edit Warehouse Route
  {
    path: "edit-warehouse/:id",
    element: <EditWarehouse />,
    allowPermission: "update-warehouse",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // provider list route
  {
    path: "providers",
    element: <ProviderList />,
    allowPermission: "show-provider",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // provider add route
  {
    path: "add-provider",
    element: <AddProvider />,
    allowPermission: "create-provider",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // provider edit route
  {
    path: "edit-provider/:id",
    element: <EditProvider />,
    allowPermission: "update-provider",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // province list route
  {
    path: "provinces",
    element: <ProvinceList />,
    allowPermission: "show-province",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // province edit route
  {
    path: "edit-province/:id",
    element: <EditProvince />,
    allowPermission: "update-province",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // facility list route
  {
    path: "facilities",
    element: <FacilityList />,
    allowPermission: "show-facility",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // facility add route
  {
    path: "add-facility",
    element: <AddFacility />,
    allowPermission: "create-facility",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // facility edit route
  {
    path: "edit-facility/:id",
    element: <EditFacility />,
    allowPermission: "update-facility",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // ip list route
  {
    path: "ips",
    element: <IPList />,
    allowPermission: "show-ip",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // ip add route
  {
    path: "add-ip",
    element: <AddIP />,
    allowPermission: "create-ip",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // ip edit route
  {
    path: "edit-ip/:id",
    element: <EditIP />,
    allowPermission: "update-ip",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // Unit Classification list route
  {
    path: "commodity-classifications",
    element: <CommodityClassificationList />,
    allowPermission: "show-commodity-classification",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // Unit Classification add route
  {
    path: "add-commodity-classification",
    element: <AddCommodityClassification />,
    allowPermission: "create-commodity-classification",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // Unit Classification edit route
  {
    path: "edit-commodity-classification/:id",
    element: <EditCommodityClassification />,
    allowPermission: "update-commodity-classification",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // fund code list route
  {
    path: "fund-codes",
    element: <FundCodeList />,
    allowPermission: "show-fund-code",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // fund code add route
  {
    path: "add-fund-code",
    element: <AddFundCode />,
    allowPermission: "create-fund-code",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // fund code edit route
  {
    path: "edit-fund-code/:id",
    element: <EditFundCode />,
    allowPermission: "update-fund-code",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // shipment list route
  {
    path: "shipments",
    element: <ShipmentList />,
    allowPermission: "show-shipment",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // shipment add route
  {
    path: "add-shipment",
    element: <AddShipment />,
    allowPermission: "create-shipment",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // shipment edit route
  {
    path: "edit-shipment/:id",
    element: <EditShipment />,
    allowPermission: "update-shipment",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // item category list route
  {
    path: "item-categories",
    element: <ItemCategoryList />,
    allowPermission: "show-item-category",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // item category add route
  {
    path: "add-item-category",
    element: <AddItemCategory />,
    allowPermission: "create-item-category",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // item category edit route
  {
    path: "edit-item-category/:id",
    element: <EditItemCategory />,
    allowPermission: "update-item-category",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // item list route
  {
    path: "items",
    element: <ItemList />,
    allowPermission: "show-item",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // item add route
  {
    path: "add-item",
    element: <AddItem />,
    allowPermission: "create-item",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // item edit route
  {
    path: "edit-item/:id",
    element: <EditItem />,
    allowPermission: "update-item",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  //user list route
  {
    path: "/users",
    element: <UserList />,
    allowRoles: ["Admin"],
  },

  //user add route
  {
    path: "/add-user",
    element: <AddUser />,
    allowRoles: ["Admin"],
  },

  //user edit route
  {
    path: "/edit-user/:id",
    element: <EditUser />,
    allowRoles: ["Admin"],
  },

  //role list route
  {
    path: "/roles",
    element: <RoleList />,
    allowRoles: ["Admin"],
  },

  //role add route
  {
    path: "/add-role",
    element: <AddRole />,
    allowRoles: ["Admin"],
  },

  //role edit route
  {
    path: "/edit-role/:id",
    element: <EditRole />,
    allowRoles: ["Admin"],
  },

  //project list route
  {
    path: "/projects",
    element: <ProjectList />,
    allowPermission: "show-project",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  //project add route
  {
    path: "/add-project",
    element: <AddProject />,
    allowPermission: "create-project",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  //project edit route
  {
    path: "/edit-project/:id",
    element: <EditProject />,
    allowPermission: "update-project",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  //profile route
  {
    path: "/profile",
    element: <Profile />,
    allowRoles: [],
  },

  //provider item in route
  {
    path: "/dashboard/provider-item-ins",
    element: <ProviderChartInItems />,
    allowRoles: ["Provider"],
  },

  //provider other source items route
  {
    path: "/dashboard/provider-other-source-items",
    element: <ProviderOtherSourceItems />,
    allowRoles: ["Provider"],
  },

  //provider exchange items route
  {
    path: "/dashboard/provider-exchange-items",
    element: <ProviderExchangeItems />,
    allowRoles: ["Provider"],
  },

  //provider adjustment increase items route
  {
    path: "/dashboard/provider-adjustment-increase",
    element: <ProviderAdjustmentIncrease />,
    allowRoles: ["Provider"],
  },

  //provider adjustment decrease items route
  {
    path: "/dashboard/provider-adjustment-decrease",
    element: <ProviderAdjustmentDecrease />,
    allowRoles: ["Provider"],
  },

  //provider item out route
  {
    path: "/dashboard/provider-item-outs",
    element: <ProviderChartOutItems />,
    allowRoles: ["Provider"],
  },

  //provider province detail route
  {
    path: "/dashboard/provider-province-detail/:provinceId",
    element: <ProviderProvinceDetail />,
    allowRoles: ["Provider"],
  },

  //provider item ip in route
  {
    path: "/dashboard/provider-ips-item-ins",
    element: <ProviderIPsChartInItems />,
    allowRoles: ["Provider"],
  },

  //provider item ip out route
  {
    path: "/dashboard/provider-ips-item-outs",
    element: <ProviderIPsChartOutItems />,
    allowRoles: ["Provider"],
  },

  //provider receipts route
  {
    path: "/provider-receipts",
    element: <ProviderInList />,
    allowRoles: ["Provider"],
    allowPermission: "show-provider-in",
  },

  //provider receipts add route
  {
    path: "/add-provider-receipts",
    element: <AddProviderIn />,
    allowRoles: ["Provider"],
    allowPermission: "create-provider-in",
  },

  //provider receipts edit route
  {
    path: "/edit-provider-receipts/:id",
    element: <EditProviderIn />,
    allowRoles: ["Provider"],
    allowPermission: "create-provider-in",
  },

  {
    path: "/edit-provider-receipts-draft/:id",
    element: <EditProviderInDraft />,
    allowRoles: ["Provider"],
    allowPermission: "create-provider-in",
  },

  //provider distributions list route
  {
    path: "/provider-distributions",
    element: <ProviderOutList />,
    allowRoles: ["Provider"],
    allowPermission: "show-provider-out",
  },

  //provider adjustments list route
  {
    path: "/provider-adjustments",
    element: <AdjustmentList />,
    allowRoles: ["Provider"],
  },
  //provider adjustments add route
  {
    path: "/add-provider-adjustments",
    element: <AddAdjustment />,
    allowRoles: ["Provider"],
  },
  //provider adjustments edit route
  {
    path: "/edit-provider-adjustments/:id",
    element: <EditAdjustment />,
    allowRoles: ["Provider"],
  },

  //provider distributions add  route
  {
    path: "/add-provider-distributions",
    element: <AddProviderOut />,
    allowRoles: ["Provider"],
    allowPermission: "create-provider-out",
  },

  //provider distributions edit  route
  {
    path: "/edit-provider-distributions/:id",
    element: <EditProviderOut />,
    allowRoles: ["Provider"],
    allowPermission: "create-provider-out",
  },

  //provider distributions draft edit route - DISABLED (using modal instead)
  // {
  //   path: "/edit-provider-distributions-draft/:id",
  //   element: <EditProviderOutDraft />,
  //   allowRoles: ["Provider"],
  //   allowPermission: "create-provider-out",
  // },

  //provider expire receipt  route
  {
    path: "/provider-expire-receipts",
    element: <ProviderExpireReceiptList />,
    allowRoles: ["Provider"],
  },

  //provider transfer to facility route
  {
    path: "/provider-transfer-to-facility",
    element: <TransferToFacilityList />,
    allowRoles: ["Provider"],
  },

  //providerRe-allocation Items route
  {
    path: "/provider-returned-items",
    element: <ReturnedItemsList />,
    allowRoles: ["Provider"],
  },

  //provider transfer history route
  {
    path: "/provider-transfers",
    element: <ProviderTransferList />,
    allowRoles: ["Provider"],
  },

  //provider expire receipt based 12 month  route
  {
    path: "/provider-expire-receipts-base-12-month",
    element: <ProviderExpireReceiptListBased12Month />,
    allowRoles: ["Provider"],
  },

  //provider consumption  route
  {
    path: "/provider-consumptions",
    element: <ProviderConsumptionReportList />,
    allowRoles: ["Provider"],
  },

  //provider stock out route
  {
    path: "/provider-stock-out",
    element: <ProviderStockOut />,
    allowRoles: ["Provider"],
  },

  //provider transaction route
  {
    path: "/provider-transactions",
    element: <ProviderTransactionList />,
    allowRoles: ["Provider"],
  },

  //provider transaction by project route
  {
    path: "/provider-transactions-by-project",
    element: <ProviderTransactionByProjectList />,
    allowRoles: ["Provider"],
  },

  //provider transaction report route
  {
    path: "/provider-receipt-reports",
    element: <ProviderReceiptReportList />,
    allowRoles: ["Provider"],
  },

  //provider distribution report route
  {
    path: "/provider-distribution-reports",
    element: <ProviderDistributionReportList />,
    allowRoles: ["Provider"],
  },

  //provider ip distribution report route
  {
    path: "/provider-ip-distribution-reports",
    element: <ProviderProvinceDistributionReportList />,
    allowRoles: ["Provider"],
  },

  //provider invetory report route
  {
    path: "/provider-inventory-reports",
    element: <ProviderInventoryList />,
    allowRoles: ["Provider"],
  },

  //provider consumptions report route
  {
    path: "/provider-consumptions-reports",
    element: <ProviderConsumptionReportList />,
    allowRoles: ["Provider"],
  },

  //provider consumptions second report route
  {
    path: "/provider-consumptions-reports-second",
    element: <ProviderConsumptionReportList2 />,
    allowRoles: ["Provider"],
  },

  //provider quantification report route
  {
    path: "/provider-quantification-report",
    element: <ProviderQuantificationReport />,
    allowRoles: ["Provider"],
  },

  //provider quantification based organization report route
  {
    path: "/provider-quantification-based-organization-report",
    element: <ProviderQuantificationOrganizationReport />,
    allowRoles: ["Provider"],
  },

  //provider M&E report route
  {
    path: "/provider-me-report",
    element: <ProviderMEReport />,
    allowRoles: ["Provider"],
  },

  //province chart items in route
  {
    path: "/dashboard/province-chart-receipts",
    element: <ProvinceChartInItems />,
    allowRoles: ["Province"],
  },

  //province chart distributions route
  {
    path: "/dashboard/province-chart-distributions",
    element: <ProvinceChartOutItems />,
    allowRoles: ["Province"],
  },

  //province map drill-down detail route
  {
    path: "/dashboard/ip-provider-province-detail/:provinceId",
    element: <ProvinceProvinceDetail />,
    allowRoles: ["Province"],
  },

  //province receipts route
  {
    path: "/province-receipts",
    element: <ProvinceInList />,
    allowRoles: ["Province"],
    allowPermission: "show-province-in",
  },

  //province distributions route
  {
    path: "/province-distributions",
    element: <ProvinceOutList />,
    allowRoles: ["Province"],
    allowPermission: "show-province-out",
  },

  //province add distributions route
  {
    path: "/add-province-distributions",
    element: <AddProvinceOut />,
    allowRoles: ["Province"],
    allowPermission: "create-province-out",
  },

  //province edit distributions route

  {
    path: "/edit-province-distributions/:id",
    element: <EditProvinceOut />,
    allowRoles: ["Province"],
    allowPermission: "update-province-out",
  },

  //province expire receipts route
  {
    path: "/province-expire-receipts",
    element: <ProvinceExpireReceiptList />,
    allowRoles: ["Province"],
  },

  //province consumption list route
  {
    path: "/province-consumptions",
    element: <ProvinceConsumptionList />,
    allowRoles: ["Province"],
  },

  //province transaction list route
  {
    path: "/province-transactions",
    element: <ProvinceTransactionList />,
    allowRoles: ["Province"],
  },

  //province consumption report list route
  {
    path: "/province-consumptions-reports",
    element: <ProvinceConsumptionReportList />,
    allowRoles: ["Province"],
  },

  //province distribution action request list route
  {
    path: "/provider-province-action-request",
    element: <ProvinceDistributionActionRequestList />,
    allowRoles: ["Provider"],
  },

  //monitor chart item in route
  {
    path: "/dashboard/monitor-item-ins",
    element: <MonitorChartInItems />,
    allowRoles: ["Monitor"],
  },

  //monitor chart item out route
  {
    path: "/dashboard/monitor-item-outs",
    element: <MonitorChartOutItems />,
    allowRoles: ["Monitor"],
  },

  //monitor province map drill-down detail route
  {
    path: "/dashboard/monitor-province-detail/:provinceId",
    element: <MonitorProvinceDetail />,
    allowRoles: ["Monitor"],
  },

  //monitor ip chart item in route
  {
    path: "/dashboard/monitor-ips-item-ins",
    element: <MonitorIPsChartInItems />,
    allowRoles: ["Monitor"],
  },

  //monitor ip chart item out route
  {
    path: "/dashboard/monitor-ips-item-outs",
    element: <MonitorIPsChartOutItems />,
    allowRoles: ["Monitor"],
  },

  //monitor receipts route
  {
    path: "/monitor-receipts",
    element: <MonitorReceipts />,
    allowRoles: ["Monitor"],
  },

  //monitor distribution route
  {
    path: "/monitor-distributions",
    element: <MonitorDistributions />,
    allowRoles: ["Monitor"],
  },

  //monitor expire receipt list route
  {
    path: "/monitor-exipre-receipts",
    element: <MonitorExpireReceiptList />,
    allowRoles: ["Monitor"],
  },

  // monitor expire receipt list base 12 month route
  {
    path: "/monitor-exipre-receipts-based-12",
    element: <MonitorExpireReceiptListBased12Month />,
    allowRoles: ["Monitor"],
  },

  // monitor stock out route
  {
    path: "/monitor-stock-out",
    element: <MonitorStockOut />,
    allowRoles: ["Monitor"],
  },
  // {
  //   path: "/monitor-consumptions",
  //   element: <MonitorConsumptionReportList />,
  //   allowRoles: ["Monitor"],
  // },

  // monitor transaction list route
  {
    path: "/monitor-transactions",
    element: <MonitorTransactionList />,
    allowRoles: ["Monitor"],
  },

  // monitor receipt report list route
  {
    path: "/monitor-receipt-reports",
    element: <MonitorReceiptReportList />,
    allowRoles: ["Monitor"],
  },

  // monitor distribution report list route
  {
    path: "/monitor-distribution-reports",
    element: <MonitorDistributionReportList />,
    allowRoles: ["Monitor"],
  },

  // monitor province distribution report list route
  {
    path: "/monitor-ip-distribution-reports",
    element: <MonitorProvinceDistributionReportList />,
    allowRoles: ["Monitor"],
  },

  // monitor inventory list route
  {
    path: "/monitor-inventory-reports",
    element: <MonitorInventoryList />,
    allowRoles: ["Monitor"],
  },

  // monitor consumption report list route
  {
    path: "/monitor-consumptions-reports",
    element: <MonitorConsumptionReportList />,
    allowRoles: ["Monitor"],
  },

  // monitor consumption report list2 route
  {
    path: "/monitor-consumptions-reports-two",
    element: <MonitorConsumptionReportList2 />,
    allowRoles: ["Monitor"],
  },

  // monitor receipt health report list route
  {
    path: "/monitor-receipt-health-reports",
    element: <MonitorReceiptHealthReportList />,
    allowRoles: ["Monitor"],
  },

  // monitor Quantification report route
  {
    path: "/monitor-quantification-report",
    element: <MonitorQuantificationReport />,
    allowRoles: ["Monitor"],
  },

  // monitor quantification organization report route
  {
    path: "/monitor-quantification-report-based-organization",
    element: <MonitorQuantificationOrganizationReport />,
    allowRoles: ["Monitor"],
  },

  // Activity logs list route
  {
    path: "/activity-logs",
    element: <ActivityLogsList />,
    allowRoles: ["Admin"],
  },

  // Provider receipt action request list route
  {
    path: "/provider-receipt-action-requests",
    element: <ProviderReceiptActionRequestList />,
    allowRoles: ["Admin"],
  },

  // Provider distribution action request list route
  {
    path: "/provider-distribution-action-requests",
    element: <ProviderDistributionActionRequestList />,
    allowRoles: ["Admin"],
  },

  // Adjustment action request list route
  {
    path: "/adjustment-action-requests",
    element: <AdjustmentActionRequestList />,
    allowRoles: ["Admin"],
  },

  //Re-allocation Management list route
  {
    path: "/return-requests",
    element: <ReturnRequestsList />,
    allowRoles: ["Admin"],
  },

  // Provider transfer requests list route (Admin)
  {
    path: "/admin/provider-transfers",
    element: <AdminProviderTransfers />,
    allowRoles: ["Admin"],
  },

  // Provider receipt health report list route
  {
    path: "/provider-receipt-health-reports",
    element: <ProviderReceiptHealthReportList />,
    allowRoles: ["Provider"],
  },

  //currency list route
  {
    path: "/currencies",
    element: <CurrencyList />,
    allowPermission: "show-currency",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  //currency add route
  {
    path: "/add-currency",
    element: <AddCurrency />,
    allowPermission: "create-currency",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  //currency edit route
  {
    path: "/edit-currency/:id",
    element: <EditCurrency />,
    allowPermission: "update-currency",
    allowRoles: ["Admin", "Provider", "Province"],
  },

  // logout route
  {
    path: "/logout",
    element: <Logout />,
    allowRoles: [],
  },

  // unauthorized users  route
  {
    path: "/unauthorized",
    element: <UnAuthorized />,
    allowRoles: [],
  },
]
